import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import '../styles.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.must_change_password ? '/changer-mot-de-passe' : '/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* Logo */}
        <div style={s.logoWrap}>
          <div style={s.logoIcon}>
            <span style={{ fontSize: 20, fontWeight: 700, color: 'white' }}>MB</span>
          </div>
          <div>
            <div style={s.logoName}>
              <span style={{ color: '#1c1c1e' }}>Matin</span>
              <span style={{ color: '#95C11F' }}> Business</span>
            </div>
            <div style={s.logoSub}>Réseau d'affaires privé</div>
          </div>
        </div>

        <h1 style={s.h1}>Connexion</h1>
        <p style={s.subtitle}>Accès réservé aux membres du réseau</p>

        <form onSubmit={handleSubmit} style={s.form}>
          <div className="mb-field">
            <label className="mb-label">Adresse email</label>
            <input
              type="email" required autoComplete="email"
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              className="mb-input"
              placeholder="votre@email.com"
            />
          </div>

          <div className="mb-field">
            <label className="mb-label">Mot de passe</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPwd ? 'text' : 'password'} required autoComplete="current-password"
                value={form.password}
                onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
                className="mb-input"
                style={{ paddingRight: 44 }}
                placeholder="••••••••"
              />
              <button type="button" onClick={() => setShowPwd(p => !p)} style={s.eyeBtn}>
                {showPwd
                  ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                }
              </button>
            </div>
          </div>

          <div style={{ textAlign: 'right', marginTop: -6, marginBottom: 8 }}>
            <a href="/mot-de-passe-oublie" style={{ fontSize: 13, color: '#95C11F', textDecoration: 'none' }}>
              Mot de passe oublié ?
            </a>
          </div>

          <button type="submit" disabled={loading} className="mb-btn mb-btn-primary mb-w-full"
            style={{ padding: '13px', fontSize: 15, justifyContent: 'center', borderRadius: 12 }}>
            {loading ? (
              <><div className="mb-spinner" style={{ width: 18, height: 18, borderWidth: 2 }} /> Connexion...</>
            ) : 'Se connecter'}
          </button>
        </form>

        <div style={s.footer}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
          </svg>
          <span style={{ fontSize: 12, color: '#8e8e93' }}>Accès sur invitation uniquement</span>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#3C2618', padding: '1rem' },
  card: { background: 'white', borderRadius: 24, padding: '2.5rem', width: '100%', maxWidth: 400, boxShadow: '0 32px 64px rgba(0,0,0,0.3)' },
  logoWrap: { display: 'flex', alignItems: 'center', gap: 14, marginBottom: '2rem', paddingBottom: '1.5rem', borderBottom: '1px solid #f2f2f7' },
  logoIcon: { width: 52, height: 52, borderRadius: 14, background: '#95C11F', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  logoName: { fontSize: 20, fontWeight: 700 },
  logoSub: { fontSize: 12, color: '#8e8e93', marginTop: 2 },
  h1: { fontSize: 24, fontWeight: 700, color: '#1c1c1e', margin: '0 0 4px' },
  subtitle: { fontSize: 14, color: '#8e8e93', margin: '0 0 1.5rem' },
  form: { display: 'flex', flexDirection: 'column' },
  eyeBtn: { position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', padding: 4 },
  footer: { marginTop: '1.5rem', paddingTop: '1rem', borderTop: '1px solid #f2f2f7', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 },
};
